export default "__VITE_ASSET__d476a566__"